/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';

import moQuestion, {
  changeQuestion,
  changeFifteen,
} from '../store';
import '../scss/common.scss';
import {
  BorderLinearProgress,
  DInput,
  NextButton,
  PrevButton,
} from '@/styled/button';
import { submitQuestion } from '@/styled/common';
import { isEmpty } from 'lodash';
import { observer } from 'mobx-react';

const FifteenQuestion = (props: any) => {
  const [type, setType] = useState('question');
  const [list1, setList1] = useState<any>([]);
  const { fifteenAnswer, curtime } = moQuestion;
  const onSave = async () => {
    const result = await submitQuestion(`${curtime}年，长期激励占比年总现金收入`, fifteenAnswer, curtime);
    if (!isEmpty(result)) {
      const res1: any = [
        {
          name: '25分位',
          all:
            result.one && result.one.p25 ? `${result.one.p25}%` : '-',
          hight:
            result.two && result.two.p25 ? `${result.two.p25}%` : '-',
          manege:
            result.three && result.three.p25 ?
              `${result.three.p25}%` :
              '-',
        },
        {
          name: '50分位',
          all:
            result.one && result.one.p50 ? `${result.one.p50}%` : '-',
          hight:
            result.two && result.two.p50 ? `${result.two.p50}%` : '-',
          manege:
            result.three && result.three.p50 ?
              `${result.three.p50}%` :
              '-',
        },
        {
          name: '75分位',
          all:
            result.one && result.one.p75 ? `${result.one.p75}%` : '-',
          hight:
            result.two && result.two.p75 ? `${result.two.p75}%` : '-',
          manege:
            result.three && result.three.p75 ?
              `${result.three.p75}%` :
              '-',
        },
        {
          name: '平均值',
          all:
            result.one && result.one.avg ? `${result.one.avg}%` : '-',
          hight:
            result.two && result.two.avg ? `${result.two.avg}%` : '-',
          manege:
            result.three && result.three.avg ?
              `${result.three.avg}%` :
              '-',
        },
      ];
      setList1(res1);
    }
    setType('answer');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className='allQuestion'>
      {type === 'question' ? (
        <section className='allContent'>
          <h2>五、长期激励<span>{'（考核周期>1年）'}</span></h2>
          <h3>5.3 {curtime}年，长期激励占比年总现金收入</h3>
          <section className='commonHead'>
            <b>高管%</b>
            <b>经理及主管%</b>
            <b>普通员工%</b>
          </section>
          <section className='commonEdit'>
            <DInput
              value={fifteenAnswer.one}
              onChange={(e: any) => {
                changeFifteen(e.target.value, 'one');
              }}/>
            <DInput
              value={fifteenAnswer.two}
              onChange={(e: any) => {
                changeFifteen(e.target.value, 'two');
              }}/>
            <DInput
              value={fifteenAnswer.three}
              onChange={(e: any) => {
                changeFifteen(e.target.value, 'three');
              }}/>
          </section>
          <p className='explanatory'>注：年固定薪酬是指年度基本工资+年度固定发放的津贴补贴。</p>
        </section>
      ) : (
        <section className='allContent'>
          <h2>五、长期激励</h2>
          <h3>5.3 {curtime}年，长期激励占比年总现金收入统计结果</h3>
          <section className='commonHead'>
            <b>分布</b>
            <b>高管</b>
            <b>经理及主管</b>
            <b>普通员工</b>
          </section>
          {list1?.map((res: any) => {
            return (
              <section className='commonShow' key={res.name}>
                <b>{res.name}</b>
                <b>{res.all}</b>
                <b>{res.hight}</b>
                <b>{res.manege}</b>
              </section>
            );
          })}
        </section>
      )}
      <section className='btnGroup'>
        <section className='numProgress'>
          <p className='num'>
            <span>15</span> / 15
          </p>
          <BorderLinearProgress variant='determinate' value={100} />
        </section>
        <PrevButton
          onClick={() => {
            changeQuestion(14);
          }}>
          上一题
        </PrevButton>
        {type === 'question' ? null : (
          <PrevButton
            onClick={() => {
              setType('question');
            }}>
            重新填写
          </PrevButton>
        )}
        {type === 'question' ? (
          <NextButton
            onClick={onSave}
            disabled={
              !fifteenAnswer.one &&
              !fifteenAnswer.two &&
              !fifteenAnswer.three
            }>
            保存查看结果
          </NextButton>
        ) : null}
      </section>
    </section>
  );
};

export default observer(FifteenQuestion);
